module.exports = __webpack_public_path__ + "static/media/fisdom_white_logo.b1e0a590.svg";